import {Injectable} from '@angular/core';
import {CommunicationCenterService} from "@modules/communication-center";
import {Subject} from "rxjs";

/**
 * This service's scope is to :
 *   - receive messages on rooms 'contextualActions' and 'contextualConditions'
 *   - expose Observables for the components of the module to subscribe to
 *   - have one Observable per action and condition handled in the module
 *   - have no other logic implemented. The components and services of the module handle the logic
 */
@Injectable({
    providedIn: 'root'
})
export class ContextualService {
    public actionGroupAdd$ = new Subject<void>();

    public conditionGroupNoGroup$ = new Subject<(boolean) => void>();
    public conditionGroupNoLearnerInGroup$ = new Subject<(boolean) => void>();

    constructor(
        private communicationCenter: CommunicationCenterService,
    ) {
        this.communicationCenter
            .getRoom('contextualActions')
            .getSubject('group')
            .subscribe((action) => {
                switch (action) {
                    case 'add':
                        this.actionGroupAdd$.next();
                        break;
                }
            });

        this.communicationCenter
            .getRoom('contextualConditions')
            .getSubject('group')
            .subscribe(({condition, callback}) => {
                switch (condition) {
                    case 'noGroup':
                        this.conditionGroupNoGroup$.next(callback);
                        break;
                    case 'noLearnerInGroup':
                        this.conditionGroupNoLearnerInGroup$.next(callback);
                        break;
                }
            });
    }

    /**
     * Notifies the contextual system that it needs to reevaluate conditions
     * following a data update.
     */
    public onConditionUpdate(): void {
        this.communicationCenter
            .getRoom('contextualUpdate')
            .next('condition', true);
    }
}
